import { useMediaQuery } from "@mui/material";
import vision from "../assets/images/vision.jpg";

function Vision() {
  const isMobile = useMediaQuery("(max-width: 720px)");
  return (
    <div className="vision">
      <div className="left-container">
        <img className="bg" src={vision} alt="" />
      </div>

      <div className="right-container">
        <h1>OUR VISION</h1>

        <p>
          We envision a world where every Tamil occasion — from intimate
          ceremonies to grand celebrations — comes to life with ease and
          authenticity. With KALYANAM, our mission is to unite all types of
          vendors on one platform, making event planning within the Tamil
          community effortless — so you can focus on the moments that truly
          matter.
        </p>
      </div>
    </div>
  );
}

export default Vision;
